export default __webpack_public_path__ + "static/media/promptings-galaxy-background.6d42c385.avif";